// extracted by mini-css-extract-plugin
export default {"fish-moving":"ThrowFish_fish-moving__eseHM","stylie-keyframes":"ThrowFish_stylie-keyframes__3QnuK","not-moving":"ThrowFish_not-moving__aLeNc"};